export default __webpack_public_path__ + "static/media/default_avatar.0cbaaf85.svg";